import React from "react";

function formatUpdated(value) {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return value;
  }
}

export default function CmsPageVersionHistoryTimeline({ history = [], selectedId, onSelect }) {
  if (!history.length) {
    return (
      <div className="cms-page-timeline">
        <h3 className="cms-page-timeline__title">Version History</h3>
        <p className="cms-page-timeline__empty">No version history yet.</p>
      </div>
    );
  }

  return (
    <div className="cms-page-timeline">
      <h3 className="cms-page-timeline__title">Version History</h3>
      <div className="cms-page-timeline__track">
        {history.map((item, index) => {
          const isActive = item.status === "ACTIVE";
          const isSelected = selectedId === item.id;
          const isLast = index === history.length - 1;

          return (
            <div
              key={item.id}
              className={`cms-page-timeline__node${isLast ? " cms-page-timeline__node--last" : ""}`}
            >
              <div className={`cms-page-timeline__dot${isActive ? " cms-page-timeline__dot--active" : ""}`} />
              <button
                type="button"
                className={`cms-page-timeline__card${isSelected ? " cms-page-timeline__card--selected" : ""}${
                  isActive ? " cms-page-timeline__card--live" : ""
                }`}
                onClick={() => onSelect?.(item)}
              >
                <div className="cms-page-timeline__card-head">
                  <span className="cms-page-timeline__version">v{item.version}</span>
                  <span className={`cms-page-status cms-page-status--${(item.status || "").toLowerCase()}`}>
                    {item.status}
                  </span>
                </div>
                <p className="cms-page-timeline__meta">Effective: {item.effectiveDate || "—"}</p>
                <p className="cms-page-timeline__meta">Updated: {formatUpdated(item.updatedAt)}</p>
                {item.updatedBy ? (
                  <p className="cms-page-timeline__meta" title={item.updatedBy}>
                    By: {item.updatedBy}
                  </p>
                ) : null}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
